export default () => {
  const buttons = document.querySelectorAll('.js-chat-activity')
  if ( buttons.length < 1 ) return
  let chatInterval
  let interval
  // Can fail locally
  ;[...buttons].forEach(button => {
    const pulse = button.querySelector('.js-pulse')
    if (window.HubSpotConversations) {
      chatInterval = window.setInterval(checkChatStatus, 5000, button, pulse)
      interval = window.setInterval(checkCookieStatus, 1000)
    } else {
      window.hsConversationsOnReady = [
        () => {
          chatInterval = window.setInterval(checkChatStatus, 5000, button, pulse)
          interval = window.setInterval(checkCookieStatus, 1000)
        }
      ];
    }
  })

  const checkChatStatus = (button, pulse) => {
    const status = window.HubSpotConversations.widget.status()
    if (status.loaded) {
      button.addEventListener('click', e => {
        e.preventDefault()
        window.HubSpotConversations.widget.open()
      })
      pulse.classList.remove('c-pulse--off')
      pulse.classList.add('c-pulse--on')
      window.clearInterval(chatInterval)
    } else {
      pulse.classList.remove('c-pulse--on')
      pulse.classList.add('c-pulse--off')
    }
  }

  const checkCookieStatus = () => {
    const status = window.HubSpotConversations.widget.status()
    const notice = document.querySelector('.js-cookie-notice')

    // If the chat is loaded and the cookie notice is still available, remove the chat. Refresh will reinstate the chat
    if (status.loaded && notice) {
      window.HubSpotConversations.widget.remove();
      window.clearInterval(interval)
    } else if (!notice) {
      window.clearInterval(interval)
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/modules/ChatActivity.js